<template>
    <div class="form-body col-md-8 col-sm-12">
      <v-row class="form-item-section personal-info-section">
        <v-row class="personal-info-row p-b-15" v-slimscroll>
          <v-col cols="12" sm="12" md="12" class="heading">
            <h3>PERSONAL INFORMATION COLLECTION STATEMENT</h3>
            <br/>
          It is often necessary for our current or prospective individual clients, or, where our clients are corporate or business entities, their individual representatives and employees (collectively referred to as "clients" and otherwise referred to as "client" , "you" or "your") to provide to Marsh (Hong Kong) Limited (hereinafter referred to as "MARSH", "we", "our" or "us" , and references to Marsh include the appropriate Marsh Affiliate (s)) personally identifiable data about yourselves ("Personal Information") in connection with our business process execution, including delivery of services and/or products, preparation of proposals, provision of quotations, arranging insurance cover, managing claims, client relationship management and conducting internal conflicts checks. Such Personal Information may include information or data provided by you or other parties or from other source, and may include, but is not limited to, historical or existing data and/or data to be collected in the future. Such Personal Information may be subject to applicable data protection, privacy and other similar laws and may include copies and other details of identity documents, proof of address and other contact details, religious, philosophical or political affiliations, information concerning age, marital status, racial or ethnic origin, education, genetic or sexual life, physical or mental health or medical condition / diagnosis, dietary preference, commission or alleged commission of any offence or proceedings for any offence committed or alleged to have been committed, the disposal of such proceedings or the sentence of any court in such proceedings.
            <br/>
            <br/>
            When you provide MARSH with Personal Information relating to your employees, dependents and / or other individuals that you represent, you will observe the provisions of any data protection or privacy legislation as applicable from time to time the extent applicable to this Agreement. This includes, without limitation: (1) an obligation, if any, for you to obtain any required consent (s) in respect of the transfer of information to MARSH by the provider or any third party relating to an identified or identifiable individual that is subject to applicable data protection, privacy or other similar laws and (ii) any obligation with respect to the use, disclosure and transfer by MARSH of personal information as necessary to carry out its obligations under this Agreement.
          </v-col>

          <v-col cols="12" sm="12" md="12" class="heading section">
            <h3>CONTACT INFORMATION</h3>
            Questions regarding this Personal information collection statement should be directed to us by writing by email to <a href="mailto:asia.information@marsh.com">asia.information@marsh.com</a> or to the following address:
          </v-col>
          <v-col cols="12" sm="12" md="12" class="heading">
            <h4>Marsh (Hong Kong) Limited<br/>Attn: Legal Department</h4>
            Suite 3402-3406, 34/F & 33/F, One Taikoo Place,
            <br/>
            979 King’s Road, Quarry Bay, Hong Kong
          </v-col>
        </v-row>
      </v-row>
      <v-col
          cols="12"
          class="button-container col-12"
          v-if="!$store.state.isEditMode"
      >

        <v-btn
            class="ma-2 form-button continue right"
            dark
            color="#0080B4"
            @click="goHome"
        >
          <span class="home-icon"></span>
          Return Home
        </v-btn>
      </v-col>
    </div>
</template>

<script>
export default {
  name: "PersonalInfoCollectionStatement-hk",
  data() {
    return {
      valid: false
    };
  },
  methods: {
    goHome: function() {
      this.$store.state.formPageNumber=0;
    }
  }
}
</script>

<style scoped>

</style>
